import i18n from '@signavio/i18n'

import { useStyles } from '@signavio/ui'
import { Nullable } from '@signavio/effektif-commons'
import { ThemeT } from '@signavio/effektif-commons'
import { ReactNode } from 'react'

export type EntityType =
  | 'case'
  | 'task'
  | 'process'
  | 'action'
  | 'milestone'
  | 'group'
  | 'form'
  | 'connector'
  | 'report'
  | 'javascript-variable'
  | 'intermediateTimer'

export default function getEntityDisplayName(
  name: Nullable<string> | undefined,
  type: EntityType,
  options?: { styledIfUnnamed: boolean }
): string | ReactNode {
  const { styledIfUnnamed } = options || {}

  if (name && name.trim()) {
    return name
  }

  let unnamed

  switch (type) {
    case 'case':
      unnamed = i18n('Unnamed case')
      break
    case 'task':
      unnamed = i18n('Unnamed task')
      break
    case 'process':
      unnamed = i18n('Unnamed process')
      break
    case 'action':
      unnamed = i18n('Unnamed action')
      break
    case 'milestone':
      unnamed = i18n('Unnamed milestone')
      break
    case 'group':
      unnamed = i18n('Unnamed group')
      break
    case 'form':
      unnamed = i18n('Unnamed form')
      break
    case 'connector':
      unnamed = i18n('Unnamed connector')
      break
    case 'report':
      unnamed = i18n('Unnamed report')
      break
    case 'javascript-variable':
      unnamed = i18n('Unnamed variable')
      break
    case 'intermediateTimer':
      unnamed = i18n('Unnamed timer')
      break
    default:
      throw new Error(`Cannot resolve display name for type ${type}`)
  }

  if (styledIfUnnamed) {
    return <UnnamedEntity unnamedType={unnamed} />
  }

  return unnamed
}

function UnnamedEntity({ unnamedType }: { unnamedType: string }) {
  const styles = useStyles(defaultStyles, {})

  return (
    <div {...styles()} data-testid="unnamed-element">
      {unnamedType}
    </div>
  )
}

const defaultStyles = ({ color }: ThemeT) => ({
  color: color.mono.middle,
  fontStyle: 'italic',
})
